import { MSym } from '@storeo/ui';
import { DemoBanner } from '../components/lumina/Placeholder';

/** Analytics & Métricas — redesign Lumina (docs/prototype/storeo_analytics_m_tricas_de_convers_o).
 *  Sem backend ainda — toda a tela é mockup fiel ao protótipo. */
export function Analytics() {
  return (
    <div className="lumina flex flex-col gap-space-lg text-on-surface">
      <div className="flex flex-col gap-space-3xs">
        <span className="font-label-sm text-label-sm uppercase tracking-wider text-primary font-bold">Inteligência de Vendas</span>
        <h1 className="font-headline-lg text-headline-lg text-on-surface tracking-tight">Analytics &amp; Métricas de Conversão</h1>
        <p className="font-body-md text-body-md text-on-surface-variant">Funil do checkout, velocidade de vendas, atribuição por canal e LTV.</p>
      </div>

      <DemoBanner />

      {/* controls */}
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-space-md bg-surface-container-low/60 p-space-md rounded-2xl shadow-sm">
        <div className="flex items-center flex-wrap gap-space-xs">
          <span className="font-label-sm text-label-sm text-on-surface-variant uppercase tracking-wider mr-space-2xs">Período:</span>
          <div className="inline-flex p-space-3xs bg-surface-container-highest/60 rounded-xl">
            {['Hoje', 'Ontem', 'Últimos 7 dias', 'Este mês'].map((p, i) => (
              <button
                key={p}
                className={`px-space-sm py-space-2xs rounded-lg font-label-md text-label-md transition-all ${
                  i === 2 ? 'bg-primary text-on-primary font-bold shadow-sm' : 'text-on-surface-variant hover:text-on-surface'
                }`}
              >
                {p}
              </button>
            ))}
          </div>
          <div className="flex items-center gap-space-xs ml-space-sm px-space-sm py-space-2xs rounded-xl bg-surface-container-high/70 text-on-surface-variant">
            <MSym name="compare_arrows" className="text-[18px] text-secondary" />
            <span className="font-label-md text-label-md text-on-surface">vs. 7 dias anteriores</span>
            <span className="font-label-sm text-label-sm px-space-2xs py-0.5 rounded bg-secondary-container/20 text-secondary">+28.6%</span>
          </div>
        </div>
        <div className="flex items-center gap-space-2xs px-space-sm py-space-2xs rounded-xl bg-surface-container text-tertiary">
          <span className="w-2 h-2 rounded-full bg-tertiary animate-pulse" />
          <span className="font-label-sm text-label-sm font-semibold tracking-wide">TELEMETRIA ATIVA</span>
        </div>
      </div>

      {/* 4 metric cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-space-lg">
        {[
          { label: 'Faturamento Bruto', value: 'R$ 384.250,00', tag: '+28.6%', foot: 'vs. R$ 298.800 sem. ant.', glow: 'bg-secondary/10', pill: 'bg-secondary-container/20 text-secondary' },
          { label: 'Taxa de Conversão Global', value: '8.42%', tag: '4.6x benchmark', foot: 'Média e-commerce BR: 1.8%', glow: 'bg-primary/10', pill: 'bg-primary-container/20 text-primary' },
          { label: 'Latência Média Checkout', value: '0.28s', tag: 'Ultra-rápido', foot: 'Abandono técnico: 0.04%', glow: 'bg-tertiary/10', pill: 'bg-tertiary-container/20 text-tertiary' },
          { label: 'LTV Médio do Cliente', value: 'R$ 289,00', tag: 'Recompra +26.4%', foot: 'Ciclo médio de 2.1 compras/cliente', glow: 'bg-secondary/10', pill: 'bg-secondary-container/20 text-secondary' },
        ].map((c) => (
          <div key={c.label} className="relative overflow-hidden p-space-lg rounded-2xl bg-surface-container-low shadow-md hover:bg-surface-container transition-all group">
            <div className={`absolute -right-6 -bottom-6 w-32 h-32 rounded-full blur-2xl pointer-events-none ${c.glow}`} />
            <div className="flex items-center justify-between mb-space-xs">
              <span className="font-label-sm text-label-sm uppercase tracking-wider text-on-surface font-semibold">{c.label}</span>
              <span className={`px-space-xs py-space-3xs rounded-full font-label-sm text-label-sm font-semibold ${c.pill}`}>{c.tag}</span>
            </div>
            <div className="font-metric-stat text-metric-stat text-white tracking-tight font-extrabold mb-space-xs">{c.value}</div>
            <div className="font-label-sm text-label-sm text-on-surface-variant">{c.foot}</div>
          </div>
        ))}
      </div>

      {/* velocity chart */}
      <div className="w-full p-space-xl rounded-2xl bg-surface-container-low shadow-md flex flex-col gap-space-md">
        <div className="flex items-center gap-space-xs">
          <h2 className="font-headline-sm text-headline-sm text-white font-bold">Velocidade de Vendas &amp; Tráfego Horário</h2>
          <span className="px-space-xs py-space-3xs rounded-full bg-secondary-container/20 text-secondary font-label-sm text-label-sm font-semibold">Pico Recorde 21h</span>
        </div>
        <div className="relative w-full h-72 bg-surface-container-lowest/70 rounded-xl p-space-md overflow-hidden">
          <svg className="w-full h-full" fill="none" preserveAspectRatio="none" viewBox="0 0 800 240">
            <defs>
              <linearGradient id="anGrad" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="#8083ff" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#8083ff" stopOpacity="0" />
              </linearGradient>
            </defs>
            {[50, 110, 170].map((y) => (
              <line key={y} stroke="#31353f" strokeDasharray="4 4" strokeWidth="1" x1="0" x2="800" y1={y} y2={y} />
            ))}
            <path d="M0,220 Q120,215 200,190 T340,150 T440,180 T560,90 T680,50 T760,120 T800,20 L800,240 L0,240 Z" fill="url(#anGrad)" />
            <path d="M0,220 Q120,215 200,190 T340,150 T440,180 T560,90 T680,50 T760,120 T800,20" fill="none" stroke="#8083ff" strokeWidth="3" strokeLinecap="round" />
            <path d="M0,210 Q160,195 320,175 T640,120 T800,80" fill="none" stroke="#4edea3" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </div>
        <div className="flex justify-between font-label-sm text-label-sm text-outline">
          {['00:00', '06:00', '12:00', '18:00', '21:00 (Pico)', '23:59'].map((t, i) => (
            <span key={t} className={i === 4 ? 'text-secondary font-bold' : ''}>
              {t}
            </span>
          ))}
        </div>
      </div>

      {/* funnel + payment split */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-space-lg">
        <div className="lg:col-span-7 p-space-xl rounded-2xl bg-surface-container-low shadow-md">
          <div className="flex items-center justify-between mb-space-md">
            <h2 className="font-headline-sm text-headline-sm text-white font-bold">Funil do Checkout Transparente</h2>
            <span className="px-space-xs py-space-3xs rounded-full bg-secondary-container/20 text-secondary font-label-sm text-label-sm font-semibold">Eficiência final: 57.1%</span>
          </div>
          <div className="space-y-space-md">
            {[
              { n: 1, label: 'Visitas na loja', v: '124.800', pct: 100 },
              { n: 2, label: 'Iniciaram o checkout', v: '38.900', pct: 31 },
              { n: 3, label: 'Preencheram os dados', v: '19.400', pct: 15.5 },
              { n: 4, label: 'Pagaram', v: '10.500', pct: 8.4 },
            ].map((s) => (
              <div key={s.n} className="p-space-sm rounded-xl bg-surface-container-high/40">
                <div className="flex justify-between items-center mb-space-2xs">
                  <div className="flex items-center gap-space-sm">
                    <span className="w-7 h-7 rounded-lg bg-surface-container-highest flex items-center justify-center font-label-md text-label-md text-primary font-bold">
                      {s.n}
                    </span>
                    <span className="font-label-md text-label-md text-white font-bold">{s.label}</span>
                  </div>
                  <div className="text-right">
                    <span className="font-label-lg text-label-lg text-white font-extrabold">{s.v}</span>
                    <span className="text-on-surface-variant font-label-sm text-label-sm block">{s.pct}% base</span>
                  </div>
                </div>
                <div className="w-full h-2 rounded-full bg-surface-container-highest overflow-hidden">
                  <div className="h-full bg-linear-to-r from-primary to-surface-tint rounded-full" style={{ width: `${s.pct}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 p-space-xl rounded-2xl bg-surface-container-low shadow-md flex flex-col gap-space-md">
          <h2 className="font-headline-sm text-headline-sm text-white font-bold">Meios de Pagamento</h2>
          <div className="space-y-space-md">
            {[
              { label: 'PIX Instantâneo', pct: 74, v: 'R$ 284.345', c: 'bg-secondary' },
              { label: 'Cartão de Crédito', pct: 22, v: 'R$ 84.535', c: 'bg-primary' },
              { label: 'Boleto', pct: 4, v: 'R$ 15.370', c: 'bg-outline' },
            ].map((r) => (
              <div key={r.label}>
                <div className="flex justify-between font-label-sm text-label-sm mb-1">
                  <span className="text-on-surface font-medium">{r.label}</span>
                  <span className="text-on-surface-variant">
                    {r.pct}% • {r.v}
                  </span>
                </div>
                <div className="w-full h-2 rounded-full bg-surface-container-highest overflow-hidden">
                  <div className={`h-full rounded-full ${r.c}`} style={{ width: `${r.pct}%` }} />
                </div>
              </div>
            ))}
          </div>
          <div className="mt-auto p-space-sm rounded-xl bg-surface-container-high/60 flex items-center gap-space-xs font-label-sm text-label-sm text-on-surface-variant">
            <MSym name="verified_user" className="text-secondary text-[16px]" /> Aprovação global: 98.2%
          </div>
        </div>
      </div>
    </div>
  );
}
